import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { useTerminal } from "@/lib/terminal";

export const TradePanel = ({ token, symbol, onDone }) => {
  const { settings, buy, sell, busy, wallet } = useTerminal();
  const [side, setSide] = useState("buy");
  const [amount, setAmount] = useState(settings.buy_presets[0]);
  useEffect(() => { setAmount(side === "buy" ? settings.buy_presets[0] : 100); }, [settings, side]);
  const isBuy = side === "buy";
  const loading = busy[`${side}-${token}`];
  const exec = async (v) => {
    const r = isBuy ? await buy(token, v, symbol) : await sell(token, v, symbol);
    if (r && onDone) onDone();
  };
  return (
    <div className="border border-[#222634] rounded-md bg-[#101216] p-3 space-y-3" data-testid="trade-panel">
      <div className="grid grid-cols-2 gap-1 p-1 rounded bg-[#08090C]">
        {["buy", "sell"].map((s) => (
          <button key={s} data-testid={`trade-tab-${s}`} onClick={() => setSide(s)}
            className={`py-1.5 rounded text-sm font-semibold transition-colors ${side === s ? (s === "buy" ? "bg-[#00E676] text-[#08090C]" : "bg-[#FF5252] text-[#08090C]") : "text-slate-400 hover:text-slate-200"}`}>
            {s === "buy" ? "Al" : "Sat"}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-4 gap-1.5">
        {(isBuy ? settings.buy_presets : settings.sell_presets).map((v) => (
          <button key={v} data-testid={`trade-preset-${side}-${v}`} disabled={loading} onClick={() => exec(v)}
            className={`py-2 rounded border text-xs font-mono font-semibold transition-colors disabled:opacity-50 ${isBuy ? "border-[#00E676]/30 text-[#00E676] hover:bg-[#00E676]/15" : "border-[#FF5252]/30 text-[#FF5252] hover:bg-[#FF5252]/15"}`}>
            {isBuy ? `${v} Ξ` : `%${v}`}
          </button>
        ))}
      </div>
      <div className="flex items-center gap-2 px-2.5 h-10 rounded border border-[#222634] bg-[#161920] focus-within:border-[#333A4E]">
        <input data-testid="trade-amount-input" type="number" min="0" step={isBuy ? "0.001" : "1"} value={amount}
          onChange={(e) => setAmount(e.target.value)} className="flex-1 bg-transparent outline-none font-mono text-sm" />
        <span className="text-xs text-slate-500 font-mono">{isBuy ? "ETH" : "%"}</span>
      </div>
      <button data-testid="trade-submit-button" disabled={loading || !Number(amount)} onClick={() => exec(Number(amount))}
        className={`w-full h-11 rounded font-bold flex items-center justify-center gap-2 transition-colors disabled:opacity-50 ${isBuy ? "bg-[#00E676] hover:bg-[#00C853] text-[#08090C]" : "bg-[#FF5252] hover:bg-[#D50000] text-[#08090C]"}`}>
        {loading && <Loader2 className="w-4 h-4 animate-spin" />}
        {isBuy ? `${amount || 0} ETH ile ${symbol} Al` : `%${amount || 0} ${symbol} Sat`}
      </button>
      <div className="flex justify-between text-[11px] font-mono text-slate-500">
        <span>Kayma: %{settings.slippage_bps / 100}</span>
        <span data-testid="trade-panel-balance">{wallet?.address ? `${wallet.trade_count} cüzdan · ${Number(wallet.eth_balance).toFixed(4)} Ξ` : "cüzdan yok"}</span>
      </div>
    </div>
  );
};
